import { useMemo } from 'react';
import { useBrandConfiguration } from '../../brands/context';
import { useStageConfiguration } from '../useStageConfiguration';
import { generateBrandBffUri, generateBrandPublicUri } from './generateBrandUri';
/**
 * useApis ensures the generation of uris depending on stage and brand
 */
export const useApis = () => {
    const { stage } = useStageConfiguration();
    const { brand, publicUriTemplate: uriTemplate } = useBrandConfiguration() || {};
    return useMemo(() => {
        const bffUri = generateBrandBffUri({
            brand,
            stage,
            uriTemplate,
        });
        const publicUri = generateBrandPublicUri({
            brand,
            stage,
            uriTemplate,
        });
        return {
            bffUri,
            publicUri,
        };
    }, [stage, brand]);
};
